import { Card } from '@/features/Cards/cards.types'
import { Balance, Token } from '@/features/Wallets/wallet.types'

export const BalancesMapper = {
  filterBalancesByAddressWithCards: (balances: Balance[], cards: Card[], publicKey: string) => {
    if (!publicKey || !balances?.length) return null

    const matchedBalance = balances.find((balance) => balance.address === publicKey)
    if (!matchedBalance) return null

    const updatedTokens = matchedBalance.tokens.map((token) => ({
      ...token,
      cards: cards ? cards?.filter((card) => card.tokenAddress === token.address) : [],
    }))

    return { ...matchedBalance, tokens: updatedTokens }
  },

  filterBySplAccount: (balances: Balance[], splAccount: string) => {
    if (!balances?.length) return null
    return balances.flatMap((balance) => balance.tokens).find((token) => token.address === splAccount)
  },

  filterTokenDelegations: (balance: Balance) => balance && balance.tokens.map((item) => item.delegation)?.filter((delegation) => delegation !== null),

  filterWhitelistedSpl: (tokens: Token[]) => tokens?.filter((token) => token.cryptoBalance.symbol === 'USDT' || token.cryptoBalance.symbol === 'USDC'),

  reconcileWalletOrder: (previousOrder: string[], balances: Balance[]): string[] => {
    const addresses = new Set(balances.map((balance) => balance.address))
    const nextOrder = previousOrder.filter((address) => addresses.has(address))

    const seen = new Set(nextOrder)
    balances.forEach((balance) => {
      if (!seen.has(balance.address)) {
        nextOrder.push(balance.address)
      }
    })

    return nextOrder
  },
}
